import { action, observable, runInAction } from 'mobx';
import { deepClone } from '../utils/deep-clone';
import { logger } from '../utils/logger';
import { deepMerge, updateObject } from '../utils/object-utils';
import { defaultDomainConfig, domainConfigValidator } from './types/config';
export const configurationSettings = {
    data: observable.object(deepClone(defaultDomainConfig)),
    setConfig: (newConfig) => {
        const config = deepMerge(configurationSettings.data, newConfig);
        const isValid = domainConfigValidator(config, logger.error, 'Configuration store data');
        if (!isValid)
            throw new Error('Some configuration settings are invalid. See the log for more details.');
        runInAction(() => updateObject(configurationSettings.data, config));
    },
    reset: action(() => (configurationSettings.data = deepClone(defaultDomainConfig)))
};
